import { createElement } from "./globalFunctions";
const newsletterEl = document.querySelector(".custom-footer__newsletter");
let newsletterHeadingEl;
if (newsletterEl)
  newsletterHeadingEl = newsletterEl.querySelector(".newsletter-header h4");
// const newsletterHeadingEl = newsletterEl.querySelector('.newsletter-header h4')

/**
 * Move the newsletter before the footer
 * @param {HTMLElement} whereToInsert - The element before which the newsletter will be inserted
 * @returns {HTMLElement} newsletterWrapper - The wrapper that contains the newsletter
 */
const moveNewsletterBeforeFooter = (whereToInsert = false) => {
  if (!newsletterEl) return;
  const pageFooter = whereToInsert || document.querySelector("#footer");
  if (!pageFooter) return;
  const newsletterWrapper = createElement("div", [
    "newsletter-wrapper",
    "container",
  ]);
  newsletterWrapper.appendChild(newsletterEl);
  pageFooter.parentElement.insertBefore(newsletterWrapper, pageFooter);
  return newsletterWrapper;
};

/**
 * Change the newsletter heading
 * You should create a global variable `newsletterNadpis` in the HTML editor
 */
const changeNewsletterHeading = () => {
  if (!newsletterHeadingEl) return;
  if (typeof newsletterNadpis !== "undefined" && newsletterHeadingEl)
    newsletterHeadingEl.innerHTML = newsletterNadpis;
};

/**
 * Create a newsletter perex
 * You should create a global variable `newsletterPerex` in the HTML editor
 */
const createNewsletterPerex = () => {
  if (!newsletterHeadingEl) return;
  if (typeof newsletterPerex !== "undefined" && newsletterPerex !== null) {
    const newsletterPerexEl = document.createElement("p");
    newsletterPerexEl.innerHTML = newsletterPerex;
    if (newsletterHeadingEl) newsletterHeadingEl.after(newsletterPerexEl);
  }
};

const addImgToNewsletter = () => {
  if (typeof newsletterImage !== "undefined" && newsletterImage !== null) {
    const newsletterImg = createElement("img", ["newsletter-img"]);
    newsletterImg.src = newsletterImage;
    newsletterImg.width = 235;
    newsletterImg.height = 235;
    const newsletterWrapper = document.querySelector(".newsletter-wrapper");

    if (typeof newsletterLink !== "undefined" && newsletterLink !== null) {
      const newsletterAnchor = createElement("a", ["newsletter-link"]);
      newsletterAnchor.href = newsletterLink;
      newsletterAnchor.target = "_blank";
      newsletterAnchor.rel = "noopener noreferrer";
      newsletterAnchor.appendChild(newsletterImg);
      if (newsletterWrapper) newsletterWrapper.prepend(newsletterAnchor);
    } else {
      if (newsletterWrapper) newsletterWrapper.prepend(newsletterImg);
    }
  }
};

export {
  moveNewsletterBeforeFooter,
  changeNewsletterHeading,
  createNewsletterPerex,
  addImgToNewsletter,
};
